import React from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TemplateForm from "../../components/WhatsAppTemplateEditor";

const CreateWhatsAppTemplate = () => {
  const history = useHistory();

  return (
    <MainContainer>
      <MainHeader>
        <Title>Criar template WhatsApp (Meta)</Title>
        <MainHeaderButtonsWrapper>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/whatsapp-templates")}
          >
            Voltar
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <TemplateForm mode="create" />
    </MainContainer>
  );
};

export default CreateWhatsAppTemplate;
